import React from 'react'
import Grid from '@mui/material/Grid'
import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'
import CircularProgress from '@mui/material/CircularProgress'
import MenuItem from '@mui/material/MenuItem'
import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import ReorderIcon from '@mui/icons-material/Reorder'
import AppsIcon from '@mui/icons-material/Apps'

import TagSelector from '../tags/TagSelector'
import { SearchStyle } from '../styles'

const ResourceSearchControls = ({
    title,
    setTitle,
    start,
    setStart,
    end,
    setEnd,
    contentTags,
    setContentTags,
    medicalTags,
    setMedicalTags,
    isLoading,
    onSubmit,
    sortRes,
    onSort,
    list,
    setList,
    sortOptions = [
        { value: 'title', label: 'Title A-Z' },
        { value: '-title', label: 'Title Z-A' },
        { value: 'pub_date', label: 'Date Ascending' },
        { value: '-pub_date', label: 'Date Descending' },
    ],
}) => {

    return (
        <>
            <form style={SearchStyle.form} onSubmit={onSubmit}>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                        <TextField
                            sx={{ width: '100%' }}
                            variant='outlined'
                            label='Search'
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <TextField
                                    sx={{ width: '100%' }}
                                    variant='outlined'
                                    type='date'
                                    label='Start Date'
                                    InputLabelProps={{ shrink: true }}
                                    value={start}
                                    onChange={(e) => setStart(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    sx={{ width: '100%' }}
                                    variant='outlined'
                                    type='date'
                                    label='End Date'
                                    InputLabelProps={{ shrink: true }}
                                    value={end}
                                    onChange={(e) => setEnd(e.target.value)}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TagSelector
                            tagType='content'
                            selectedTags={contentTags}
                            onChange={setContentTags}
                            multiple={true}
                            label='Tags'
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TagSelector
                            tagType='medicalSpecialty'
                            selectedTags={medicalTags}
                            onChange={setMedicalTags}
                            multiple={true}
                            label='Medical Specialty'
                        />
                    </Grid>

                </Grid>
            </form>

            <Grid container spacing={2} sx={SearchStyle.filtersContainer}>
                <Grid item xs={12} md={sortOptions.length > 0 ? 6 : 9}>
                    <Button
                        sx={SearchStyle.searchButton}
                        fullWidth
                        variant='contained'
                        disabled={isLoading}
                        onClick={onSubmit}
                    >
                        {isLoading ? (
                            <CircularProgress size={24} sx={{ color: '#FFF' }} />
                        ) : (
                            <>Search</>
                        )}
                    </Button>
                </Grid>
                {sortOptions.length > 0 && (
                    <Grid item xs={12} md={3}>
                        <TextField
                            fullWidth
                            value={sortRes}
                            select
                            label='Sort By'
                            onChange={onSort}
                        >
                            {sortOptions.map((option) => (
                                <MenuItem key={option.value} value={option.value}>
                                    {option.label}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                )}
                <Grid item xs={12} md={3}>
                    <Box sx={SearchStyle.viewContainer}>
                        <IconButton sx={{ color: list ? '#002A5C' : '#CECFCB' }} onClick={() => setList(true)}>
                            <ReorderIcon />
                        </IconButton>
                        <IconButton sx={{ color: !list ? '#002A5C' : '#CECFCB' }} onClick={() => setList(false)}>
                            <AppsIcon />
                        </IconButton>
                    </Box>
                </Grid>
            </Grid>
        </>
    )
}

export default ResourceSearchControls
